module.exports = __webpack_public_path__ + "static/media/Start Screeen-02.27d7d6ed.webp";